export default __webpack_public_path__ + "static/media/nigel_sidepanel_empty.0e3cfb43.svg";